/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChatStatisticsViewModel } from "../types/ChatStatisticsViewModel.ts";
import { chatStatisticsIntervalViewModelSchema } from "./chatStatisticsIntervalViewModelSchema.ts";

export const chatStatisticsViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  dateStart: z.optional(z.string().datetime()),
  dateFinish: z.optional(z.string().datetime()),
  openingTime: z.optional(z.string().datetime()),
  closingTime: z.optional(z.string().datetime()),
  datePeak: z.optional(z.string().datetime()),
  maximumQuantity: z.optional(z.number().int()),
  averageQuantity: z.optional(z.number()),
  averageTime: z.optional(z.number()),
  activeStudents: z.optional(z.number().int()),
  activePercentage: z.string().nullish(),
  accessCount: z.optional(z.number().int()),
  teacherName: z.string().nullish(),
  disciplineText: z.string().nullish(),
  classStudentCode: z.string().nullish(),
  intervals: z
    .array(z.lazy(() => chatStatisticsIntervalViewModelSchema))
    .nullish(),
}) as unknown as ToZod<ChatStatisticsViewModel>;
